import styled from 'styled-components';
import { Background } from 'components/Generics/Background/Background.style';
import { ApricotBackground } from 'components/Generics/Background/ApricotBackground.style';
export const Content = styled.div`
    height: 82%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
`;

export const ApricotLogoutMsg = styled.div`
    margin: 5vw 10vw 3vw 18vw;   // margin: top right bottom left;
    font-size: 4vw;
    font-family: 'Graphik Semibold', 'sans-serif';
    color: #003d50;
`;

export {
    Background,
    ApricotBackground
};